import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowForward = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M9.18633 3.83911L14.1223 8.77505L9.18633 13.711M13.4367 8.77505H3.42773",
		stroke: "currentColor",
		strokeWidth: 1.64531,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowForward;
